/**
 * @Author: Jon Lucas
 * @Date:   2017-09-12T11:07:07+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-12T11:08:25+02:00
 */

import { Injector } from "@angular/core";
/**
 * https://stackoverflow.com/questions/33970645/how-to-extend-a-component-with-dependency-injection-in-angular-2
 *
 * @type {Injector}
 */
export class ServiceLocator {
    public static injector: Injector;
}



// WEBPACK FOOTER //
// ./src/app/service-locator.ts